import ApiService from "@/services/api.service";
import { UserLoginService } from "@/services/api.service";
import JwtService from "@/services/jwt.service";
import ModuleAccessService from "@/services/access-module.service";
import {
  LOGIN,
  LOGOUT,
  RESET_PASSWORD,
  //REGISTER,
  CHECK_AUTH
  // UPDATE_USER
} from "./actions.type";
import { SET_AUTH, PURGE_AUTH, SET_ERROR } from "./mutations.type";
import { resolve } from "core-js/fn/promise";

const state = {
  errors: null,
  user: {},
  username: null,
  isAuthenticated: !!JwtService.getToken(),
  isAdministrator: false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  isAdministrator(state) {
    return state.isAdministrator;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("users/login", { user: credentials.payload })
        .then(response => {
          //console.log(response);

          if (response.status == 200 && response.data.user) {
            context.commit(SET_AUTH, response.data.user);
            //return { success: response.data.message.success };
          }
          resolve(response);
        })
        .catch(response => {
          //console.log(response);
          context.commit(SET_ERROR, response);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  async [RESET_PASSWORD](context, payload) {
    // console.log("store", payload)
    return new Promise(resolve => {
      UserLoginService.reset_password(`change-password/${payload.user_id}`, {
        params: payload.data,
        current_password: payload.password_current
      })
        .then(response => {
          // console.log(response);
          resolve(response);
        })
        .catch(response => {
          //console.log(response);
          return response;
        });
    });

    console.log("resp", resp);
  },
  [CHECK_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      /*ApiService.get("user")
        .then(({ data }) => {
          context.commit(SET_AUTH, data.user);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
        });*/
    } else {
      context.commit(PURGE_AUTH);
    }
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    // console.log(user);
    state.isAuthenticated = true;
    state.user = user;
    state.username = user.user.username;
    state.errors = {};
    JwtService.saveToken(state.user.access_token);
    JwtService.saveUser(state.user.user);
    state.isAdministrator =
      ModuleAccessService.getRole() == "Administrators" ? true : false;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.isAdministrator = false;
    state.user = {};
    state.user.username = null;
    state.errors = {};
    JwtService.destroyToken();
    JwtService.destroyUser();
  }
};

export default {
  //namespaced: true,
  state,
  actions,
  mutations,
  getters
};
